import { SVGProps } from 'react';

const MailIcon = ({
  fill = '#EAEAEA',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 6.08615C1 4.76067 2.07452 3.68616 3.4 3.68616H14.6C15.9255 3.68616 17 4.76067 17 6.08616V13.2568C17 14.5823 15.9255 15.6568 14.6 15.6568H3.4C2.07452 15.6568 1 14.5823 1 13.2568V6.08615ZM2.2998 6.18303C2.2998 5.52029 2.83706 4.98303 3.4998 4.98303H14.4998C15.1625 4.98303 15.6998 5.52029 15.6998 6.18303V13.16C15.6998 13.8228 15.1625 14.36 14.4998 14.36H3.49981C2.83706 14.36 2.2998 13.8228 2.2998 13.16V6.18303ZM8.60154 10.5343C8.72671 10.6124 8.8638 10.6467 8.99671 10.6413C9.12876 10.6461 9.26483 10.6118 9.38914 10.5342L14.1248 7.57949C14.4681 7.36534 14.5918 6.90246 14.4011 6.54563C14.2105 6.1888 13.7777 6.07314 13.4345 6.28729L8.99526 9.05706L4.55621 6.28739C4.21298 6.07324 3.78019 6.1889 3.58955 6.54573C3.39892 6.90257 3.52262 7.36544 3.86586 7.5796L8.60154 10.5343Z" fill="#EAEAEA" />
  </svg>
);

export default MailIcon;
